<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        :md="cols[0]"
      >
        <v-card
          class="mx-auto my-3"
          max-width="400"
        >
          <v-img
            class="white--text align-end"
            height="200px"
            src="@/assets/portfolio/img/daily.png"
            gradient="to bottom left, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            position="top"
          >
            <v-card-title>Daily Food Intake</v-card-title>
          </v-img>

          <v-card-text class="text--primary">
            <div>This project is a mobile web app that helps you to track the daily food intake that you should eat and show a histogram with daily progress.</div>
          </v-card-text>
          <v-card-text class="text--primary">
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-react</v-icon>
              </v-avatar>
              React
            </v-chip>
    
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-ruby</v-icon>
              </v-avatar>
              Ruby
            </v-chip>
  
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-html5</v-icon>
              </v-avatar>
              HTML 5
            </v-chip>
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-css3</v-icon>
              </v-avatar>
              CSS 3
            </v-chip>
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-bootstrap</v-icon>
              </v-avatar>
              Bootstrap
            </v-chip>
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-javascript</v-icon>
              </v-avatar>
              JavaScript
            </v-chip>
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-ruby-on-rails</v-icon>
              </v-avatar>
              Rails
            </v-chip>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="black"
              text
              href="https://fast-shelf-63763.herokuapp.com/"
              target="_blank"
            >
              <span class="link-underline">Live Demo</span>  <v-icon>mdi-link-box</v-icon>
            </v-btn>

            <v-btn
              color="black"
              text
              href="https://github.com/jstiven01/daily-food-intake-app"
              target="_blank"
            >
              <span class="link-underline">View Source </span>  <v-icon>mdi-github-circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        :md="cols[0]"
      >
        <v-card
          class="mx-auto my-3"
          max-width="400"
        >
          <v-img
            class="white--text align-end"
            height="200px"
            src="@/assets/portfolio/img/PortFolio.png"
            gradient="to bottom left, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            position="top"
          >
            <v-card-title>Personal Portfolio</v-card-title>
          </v-img>

          <v-card-text class="text--primary">
            <div>This personal portfolio to show my experience and expertise as a software developer.</div>
          </v-card-text>
          <v-card-text class="text--primary">
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-vuejs</v-icon>
              </v-avatar>
              Vuejs
            </v-chip>
    
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-vuetify</v-icon>
              </v-avatar>
              Vuetify
            </v-chip>

            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-css3</v-icon>
              </v-avatar>
              CSS 3
            </v-chip>
  
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-html5</v-icon>
              </v-avatar>
              HTML 5
            </v-chip>


            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-javascript</v-icon>
              </v-avatar>
              JavaScript
            </v-chip>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="black"
              text
              href="https://jstiven01.github.io/"
              target="_blank"
            >
              <span class="link-underline">Live Demo</span>  <v-icon>mdi-link-box</v-icon>
            </v-btn>

            <v-btn
              color="black"
              text
              href="https://github.com/jstiven01/personal-portfolio"
              target="_blank"
            >
              <span class="link-underline">View Source </span>  <v-icon>mdi-github-circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        :md="cols[0]"
      >
        <v-card
          class="mx-auto my-3"
          max-width="400"
        >
          <v-img
            class="white--text align-end"
            height="200px"
            src="@/assets/portfolio/img/fbclone.png"
            gradient="to bottom left, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            position="top"
          >
            <v-card-title>Facebook Clone</v-card-title>
          </v-img>

          <v-card-text class="text--primary">
            <div>This project is about building a large portion of the core Facebook user functionality.</div>
          </v-card-text>
          <v-card-text class="text--primary">
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-ruby</v-icon>
              </v-avatar>
              Ruby
            </v-chip>
  
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-html5</v-icon>
              </v-avatar>
              HTML 5
            </v-chip>
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-css3</v-icon>
              </v-avatar>
              CSS 3
            </v-chip>
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-bootstrap</v-icon>
              </v-avatar>
              Bootstrap
            </v-chip>
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-ruby-on-rails</v-icon>
              </v-avatar>
              Rails
            </v-chip>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="black"
              text
              href="https://intense-reaches-58174.herokuapp.com/users/sign_in"
              target="_blank"
            >
              <span class="link-underline">Live Demo</span>  <v-icon>mdi-link-box</v-icon>
            </v-btn>

            <v-btn
              color="black"
              text
              href="https://github.com/jstiven01/facebook-clone"
              target="_blank"
            >
              <span class="link-underline">View Source </span>  <v-icon>mdi-github-circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        :md="cols[0]"
      >
        <v-card
          class="mx-auto my-3"
          max-width="400"
        >
          <v-img
            class="white--text align-end"
            height="200px"
            src="@/assets/portfolio/img/jsBattle.png"
            gradient="to bottom left, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            aspect-ratio="1"
            contain       
          >
            <v-card-title>Battleship Game</v-card-title>
          </v-img>

          <v-card-text class="text--primary">
            <div>This project is about implementing the battleship game using JavaScript.Test-Driven Development (TDD) was implemented with the Jest framework.</div>
          </v-card-text>
          <v-card-text class="text--primary">
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-javascript</v-icon>
              </v-avatar>
              JavaScript
            </v-chip>
  
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-html5</v-icon>
              </v-avatar>
              HTML 5
            </v-chip>
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-language-css3</v-icon>
              </v-avatar>
              CSS 3
            </v-chip>
            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-bootstrap</v-icon>
              </v-avatar>
              Bootstrap
            </v-chip>

            <v-chip
              class="ma-2"
              color="indigo"
              text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-webpack</v-icon>
              </v-avatar>
              Webpack
            </v-chip>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="black"
              text
              href="https://jstiven01.github.io/js-battleship/"
              target="_blank"
            >
              <span class="link-underline">Live Demo</span>  <v-icon>mdi-link-box</v-icon>
            </v-btn>

            <v-btn
              color="black"
              text
              href="https://github.com/jstiven01/js-battleship"
              target="_blank"
            >
              <span class="link-underline">View Source </span>  <v-icon>mdi-github-circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed:{
      cols () {
            const { lg, md } = this.$vuetify.breakpoint
            return lg ? [6, 6] : md ? [6, 6] : [10, 2]
      }
  }
}
</script>

<style scoped>
 .link-underline{
   text-decoration: underline;
 }
</style>

